import { render } from "./more-recommend.vue?vue&type=template&id=39108fa6&scoped=true"
import script from "./more-recommend.vue?vue&type=script&lang=ts"
export * from "./more-recommend.vue?vue&type=script&lang=ts"

import "./more-recommend.vue?vue&type=style&index=0&id=39108fa6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39108fa6"

export default script